import { render } from "./FreeBenefits.vue?vue&type=template&id=79bd615f&scoped=true"
import script from "./FreeBenefits.vue?vue&type=script&lang=js"
export * from "./FreeBenefits.vue?vue&type=script&lang=js"

import "./FreeBenefits.vue?vue&type=style&index=0&id=79bd615f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79bd615f"]])

export default __exports__